module.exports = __webpack_public_path__ + "static/media/gameTicketTaker.acf762da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameTicketTaker.png
// module id = 2603
// module chunks = 0